import {

    List,
    Datagrid,
    TextField, NumberField, ReferenceField, TopToolbar, CreateButton, ExportButton, useRecordContext, BooleanField,
    useDataProvider,
    DataProviderContext,
} from 'react-admin';
import FormattedDateTimeField from "../../../common/FormattedDateTimeField";
import { NoDataSection } from "../../../common/NoDataSection";
import FullNameField from '../../../common/FullNameField';
import { format } from 'date-fns';
import { downloadCSV, jsonToCSV } from '../../../common/CSVExport';
import MonthSelector from '../../../common/MonthSelector';
import { useMemo, useState } from 'react';
import { createCustomGoDataProvider } from '../../../services';

const myCustomExporter = (records: any) => {
    const data = records.map((record: any) => {
        return {
            ...record,
            joined_at: format(new Date(record.joined_at), 'dd-MMM-yyyy hh:mm a'),
            expired_at: format(new Date(record.expired_at), 'dd-MMM-yyyy hh:mm a'),
        };
    });
    const csv = jsonToCSV(data); // Convert the modified data to CSV format
    downloadCSV(csv, 'Batch Students Report');  // Download the CSV
};


const ReportBatchStudentList = () => {
    const [selectedMonthRange, setSelectedMonthRange] = useState<{ firstDay: any, lastDay: any, month: any } | null>(null);
    const ListActions = () => (
        <TopToolbar className="">
            <MonthSelector monthsToShow={12} setSelectedMonthRange={setSelectedMonthRange} selectedMonthRange={selectedMonthRange} />
            <ExportButton />
        </TopToolbar>
    );
    const baseDataProvider = useDataProvider();
    const customDataProvider = useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'report_batch_students', apiEndpoint: '/batches/reports/enrollments' },
            ]),
        [baseDataProvider],
    );
    const listFilter = selectedMonthRange
        ? { monthYear: selectedMonthRange.month }
        : {};


    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <List
                actions={<ListActions />}
                    filter={listFilter}
                exporter={myCustomExporter}
                resource={'report_batch_students'}
                empty={<NoDataSection resource={'report_batch_students'} />}>
                <Datagrid bulkActionButtons={false}>
                    <TextField source="batch" />
                    <TextField source="student.email" label="Email" />
                    <FormattedDateTimeField source="createdAt" label="Joined At" />
                    <FormattedDateTimeField source="endsOn" label="Expired At" />
                    <TextField source="student.phone" label="Phone" />
                </Datagrid>
            </List>
        </DataProviderContext.Provider>
    );
};
export default ReportBatchStudentList;
